<template>
  <ContractEditorCore
    mode="contract"
    :non-editable-component="nonEditableComponent"
    :editor-component="editorComponent"
    :show-start-date="true"
    :show-payment-validation="true"
    :responsable-from-state="'contract'"
    :document-label="'Contrato'"
    @open-cost-breakdown-modal="openCostBreakdownModal"
  >
  </ContractEditorCore>
</template>

<script>
import ContractEditorCore from './ContractEditorCore.vue'
import NonEditableContract from './NonEditableContract.vue'
import TextEditor from '@/components/Helpers/Editor/TextEditor'
export default {
  name: 'ContractDetail',
  components: { ContractEditorCore },
  data() {
    return {
      nonEditableComponent: NonEditableContract,
      editorComponent:      TextEditor,
    }
  },
  methods: {
    openCostBreakdownModal() {
      this.$store.commit('costbreakdown/setCostBreakdownSummaryTablesModal', true)
    },
  },
}
</script>